export default "/images/recruit-personal-dashboard.webp?b953a42776949678481ee149d955fc27";